<template>
    <BModal ref="modal" :title="title" centered header-class="modal-title" modal-class="no-border-modal">
        <p :class="['fw-bold', 'mb-0', active ? 'text-success' : 'text-danger']">{{ text }}</p>
        <template #footer="{ cancel }">
            <div class="d-flex justify-content-end w-100">
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('common.close') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

// Connection state of an equipment with the date of its last change, as in the app
export default {
    name: 'StateInfoModal',
    components: {
        BModal
    },
    setup() {
        const modal = ref(null);
        const title = ref('');
        const text = ref('');
        const active = ref(false);

        const show = (equipmentLabel, stateText, isActive) => {
            title.value = equipmentLabel;
            text.value = stateText;
            active.value = isActive;
            modal.value.show();
        };

        return {
            modal,
            title,
            text,
            active,
            show,
        };
    }
}
</script>
